import React from "react";
import HelpModal from "common/HelpModal";

const HTTPCompressionHourlyVolumeAndRatioHelpModal = () => (
  <HelpModal
    title="BTC Statistics"
    content={() => (
      <>
        <p>HTTP compession data statistics.</p>
        <p>Chart selectors:</p>
        <ul>
          <li>
            <i className="material-icons valign-icon">timeline</i> Selects the
            type of chart from:
          </li>
          <ul>
            <li>
              <b>Volume:</b> volume of traffic compressed, both before
              compression (In) and after compression (Out).
            </li>
            <li>
              <b>Compression Ratio:</b> compression ratio achieved (volume
              before compression divided by volume after compression, in %).
            </li>
          </ul>
          <li>
            <i className="material-icons valign-icon">date_range</i> Selects the
            range of time values shown starting from now: 1 day, 1 week or 1
            month. The slider at the bottom of the graph allows refining the
            range of date values shown: a shorter interval by dragging any of
            the dated labels and, once done, by dragging the central part.
          </li>
        </ul>
        <p>
          Click on the <i className="material-icons valign-icon">refresh</i>{" "}
          icon to refresh the HTTP compression statistics.
        </p>
      </>
    )}
  />
);

export default HTTPCompressionHourlyVolumeAndRatioHelpModal;
